import { render, staticRenderFns } from "./tBurialSearch.vue?vue&type=template&id=3d361abb&scoped=true"
import script from "./tBurialSearch.vue?vue&type=script&lang=js"
export * from "./tBurialSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d361abb",
  null
  
)

export default component.exports